import {
    MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader
} from 'mdb-react-ui-kit';
import { FaTimes } from 'react-icons/fa';
import React from 'react';
const TabViewModal = (props) => {
    const { showMenu, showMenuToggle } = props;
    return (
        <MDBModal show={showMenu} tabIndex='-1' staticBackdrop>
            <MDBModalDialog className="modal-dialog-bottom">
                <MDBModalContent className='header-container'>
                    <MDBModalHeader className='ms-auto border-0'>
                        <FaTimes color='white' size={23} onClick={showMenuToggle} />
                    </MDBModalHeader>
                    <MDBModalBody>
                        <ul className='p-0 px-5'>
                            <li className='p-3'><a className='text-white fw-bold' href='#intro-container'>HOME</a></li>
                            <li className='p-3'><a className='text-white fw-bold' href='#about-container'>ABOUT</a></li>
                            <li className='p-3'><a className='text-white fw-bold' href='#skill-container'>SKILLS</a></li>
                            <li className='p-3'><a className='text-white fw-bold' href='#skill-container'>CONTACT</a></li>
                        </ul>
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    )
}

export default TabViewModal;